// extracted by mini-css-extract-plugin
export const sectionRoot = "H_bF";
export const designRoot = "H_bM";
export const contentRoot = "H_bH";
export const stepRoot = "H_bJ";
export const stepIcon = "H_bK";
export const stepTitle = "H_bL";
export const btnDesign = "H_bN";
export const videoRoot = "H_bP";